<script>
  import { onMount, getContext } from 'svelte';
  import { watchQuery } from '../../apollo/client';

  import { SEARCH_COORDINATORS } from '../../graphql/coordinators';

  const client = getContext('apollo');

  export let label;
  export let value;
  export let placeholder = null;
  export let readonly = false;

  let opts = {
    query: SEARCH_COORDINATORS
  };
  let results = { loading: true };

  function setResponse({ data, loading, error, networkStatus }) {
    results = {
      loading,
      coordinators: data && data.coordinators ? data.coordinators.docs : []
    };
  }

  let [query, subscription] = watchQuery(client, opts, setResponse);
</script>

<div>
  <!-- LABEL -->
  {#if label}
  <label>{label}</label>
  {/if}
  <!-- LOADER -->
  {#if results.loading}
  <select disabled="{readonly}" readonly="{readonly}">
    <option value="{null}">Loading Coordinators...</option>
  </select>
  {/if}
  <!-- COMPONENT -->
  {#if !results.loading}
  <select
    on:change
    class:placeholder="{!value}"
    disabled="{readonly}"
    readonly="{readonly}"
    bind:value
  >
    <option value="{null}"
      >{placeholder || 'Choose a Program Coordinator'}</option
    >
    {#each results.coordinators as coordinator, i}
    <option value="{coordinator.id}">
      {coordinator.firstName} {coordinator.lastName}
    </option>
    {/each}
  </select>
  {/if}
</div>
